export default __webpack_public_path__ + "static/media/picked-icon.c64008ae.svg";